import { Terms as TermsProtos } from '@qover-private/protos-web/qover/dojo/travel/v1/terms';
import { Terms } from '../Terms';

export function mapToApiRequest(terms: Terms): TermsProtos {
  return {
    ...terms,
    cancellationClaimAmount: terms.hasCancellationTrip
      ? terms.cancellationClaimAmount
      : undefined,
  };
}
